"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportBug = void 0;
var js_1 = require("@mdi/js");
var react_1 = __importDefault(require("@mdi/react"));
var react_2 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var react_router_1 = require("react-router");
var __1 = require("../..");
var ReportBug = function () {
    var _a = (0, __1.useEloise)(), siteConfig = _a.siteConfig, theme = _a.theme, logic = _a.logic;
    var _b = (0, react_2.useState)("Description"), desc = _b[0], setDesc = _b[1];
    var _c = (0, react_2.useState)("Message"), message = _c[0], setMessage = _c[1];
    var _d = (0, react_2.useState)(), page = _d[0], setPage = _d[1];
    var _e = (0, react_2.useState)(siteConfig.defaultMode), siteMode = _e[0], setSiteMode = _e[1];
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var locTest, test_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    locTest = logic.hooks.useLocalStorage("siteMode");
                    if (locTest) {
                        setSiteMode(locTest);
                    }
                    if (!!locTest) return [3 /*break*/, 2];
                    return [4 /*yield*/, logic.fb.docs.getUserDoc("")];
                case 1:
                    test_1 = _a.sent();
                    if (test_1 && test_1.siteMode) {
                        setSiteMode(test_1.siteMode);
                        localStorage.setItem("siteMode", test_1.siteMode);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); });
    var pages = typeof siteConfig.pages === "function"
        ? siteConfig.pages(siteMode)
        : siteConfig.pages;
    var pageOptions = pages.map(function (page) {
        if (page.name === "/")
            return "Home";
        return page.name;
    });
    var bugReporting = true; //todo replace with siteConfig field
    var navigate = (0, react_router_1.useNavigate)();
    return (react_2.default.createElement("div", null,
        react_2.default.createElement(react_bootstrap_1.Row, null,
            react_2.default.createElement(react_bootstrap_1.Col, { className: "mx-auto", lg: 7, style: {
                    border: "3px solid ".concat(theme.colors[0]),
                    borderRadius: "5px",
                } },
                react_2.default.createElement(react_bootstrap_1.Row, null,
                    react_2.default.createElement(__1.Heading, { size: 4 }, "Report a Bug"),
                    react_2.default.createElement(__1.Heading, { size: 1, style: {
                            borderBottom: "2px solid ".concat(theme.colors[0]),
                            borderRadius: 0,
                        } }, "Answer a few questions about the bug you experienced. We really appreciate it!")),
                react_2.default.createElement(react_bootstrap_1.Row, { className: "mt-3" },
                    react_2.default.createElement(react_bootstrap_1.Col, { lg: 8 },
                        react_2.default.createElement(react_bootstrap_1.Row, { className: "my-3" },
                            react_2.default.createElement(react_bootstrap_1.Col, { lg: 8 },
                                react_2.default.createElement(__1.Heading, { size: 1, align: "left" }, "Where did this bug occur?")),
                            react_2.default.createElement(react_bootstrap_1.Col, { lg: 4 },
                                react_2.default.createElement(__1.DropDown, { state: page, setState: setPage, options: pageOptions, label: "Page" }))),
                        react_2.default.createElement(react_bootstrap_1.Row, null,
                            react_2.default.createElement(react_bootstrap_1.Col, { lg: 8 },
                                react_2.default.createElement(__1.Heading, { size: 1, align: "left" }, "What happened exactly?"))),
                        react_2.default.createElement(react_bootstrap_1.Row, null,
                            react_2.default.createElement(__1.LargeTextInput, { state: desc, setState: setDesc }))),
                    react_2.default.createElement(react_bootstrap_1.Col, { lg: 4, className: "text-center" },
                        react_2.default.createElement(__1.View, null,
                            react_2.default.createElement(react_1.default, { color: theme.colors[0], path: js_1.mdiBugOutline, size: 6 })))),
                react_2.default.createElement(react_bootstrap_1.Row, null,
                    react_2.default.createElement(react_bootstrap_1.Col, { lg: 8 },
                        react_2.default.createElement(__1.Heading, { size: 1, align: "left" }, "Anything else you want to tell the Dev team?"))),
                react_2.default.createElement(react_bootstrap_1.Row, null,
                    react_2.default.createElement(__1.LargeTextInput, { state: message, setState: setMessage })),
                react_2.default.createElement(react_bootstrap_1.Row, null,
                    react_2.default.createElement(react_bootstrap_1.Col, { lg: 4, className: "mx-auto mb-3" },
                        react_2.default.createElement(__1.Button, null, "Submit")))))));
};
exports.ReportBug = ReportBug;
